import { chatEvent } from '@/domains/common/api';
import { defineRouteDef, z } from '@/domains/common/api';

export const confirmChatRoute = defineRouteDef({
  method: 'POST',
  path: '/api/chat/confirm',
  audience: 'user',
  body: z.object({
    pending_call_id: z.uuid(),
    recommendation: z.enum(['confirm', 'reject']),
  }),
  events: chatEvent,
});
